import { runtimeEnv } from './runtimeEnv';

export const APP_NAME =
  runtimeEnv('REACT_APP_NAME') ?? process.env.REACT_APP_NAME ?? 'PR NewsCraft AI';
export const APP_VERSION =
  runtimeEnv('REACT_APP_VERSION') ?? process.env.REACT_APP_VERSION ?? '1.0.0';

/** API origin without path (scheme + host + port). */
export const API_DOMAIN = (
  runtimeEnv('REACT_APP_API_DOMAIN') ??
  process.env.REACT_APP_API_DOMAIN ??
  'http://localhost:5000'
).replace(/\/+$/, '');
export const API_BASE_URL = `${API_DOMAIN}/api/v1`;
export const API_TIMEOUT =
  Number(runtimeEnv('REACT_APP_API_TIMEOUT') ?? process.env.REACT_APP_API_TIMEOUT) || 30000;

export const STORAGE_KEYS = {
  THEME: 'pr-gen-theme',
  AUTH: 'pr-gen-auth',
  SESSION: 'pr-gen-session',
} as const;

export const PERMISSIONS = {
  VIEW_DASHBOARD: 'view:dashboard',
  VIEW_COVERAGE: 'view:coverage',
  EDIT_COVERAGE: 'edit:coverage',
  VIEW_NEWSLETTERS: 'view:newsletters',
  EDIT_NEWSLETTERS: 'edit:newsletters',
  REVIEW_NEWSLETTERS: 'review:newsletters',
  VIEW_GOALS: 'view:goals',
  EDIT_GOALS: 'edit:goals',
  VIEW_CHAT: 'view:chat',
  ADMIN_SETTINGS: 'admin:settings',
  // Read-only executive surface (/exec/*). Granted ONLY to the
  // `executive` role and gates the entire `/exec` route tree.
  VIEW_EXEC: 'view:exec',
} as const;

// Admin-default permission bundle. Intentionally EXCLUDES `view:exec`
// so that the executive surface is reachable only by users explicitly
// assigned the `executive` role.
export const DEFAULT_PERMISSIONS = Object.values(PERMISSIONS).filter(
  (p) => p !== PERMISSIONS.VIEW_EXEC,
);
